import script from "./RoleManager.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleManager.vue?vue&type=script&setup=true&lang=js"

import "./RoleManager.vue?vue&type=style&index=0&id=78d6c930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d6c930"]])

export default __exports__